import styled, { withTheme } from 'styled-components'
import media from '../../../utils/style'
import typography from '../../../utils/typography'

const SearchInput = styled.input`
  font-size: 16px;
  font-family: ${(props) => props.theme.font};
  color: ${(props) => props.theme.colors.grey};
  height: ${typography.rhythm(1.29)};
  ${media.LargeScreenUp`
    font-size: 14px;
    height: ${typography.rhythm(1.97)};
  `};
  width: 100%;
  padding-left: 70px;
  background: white;
  border: none;
  outline: none;
  &::placeholder {
    display: none;
    color: white;
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    ${media.LargeScreenUp`
      color: ${(props) => props.theme.colors.grey_light};
    `};
  }
  &:focus {
    outline: none;
  }
  &:focus,
  &:hover {
    &::placeholder {
      color: ${(props) => props.theme.colors.white};
      ${media.LargeScreenUp`
        color: ${(props) => props.theme.colors.grey_op90};
      `};
    }
  }
`

export default withTheme(SearchInput)
